import React, { useState, useEffect } from 'react'
import NumberPatients from './numberPatients';
import QRCode from "qrcode.react"
import axios from 'axios';
import LoadingOverlay from 'react-loading-overlay';
import {getCsrfToken} from '../../commons/authenticityToken';

declare global {
  interface Window { clipboardData: any; }
}

export const PatientCount = React.createContext(undefined);

const index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
  //ページ数
  const [ currentPage, setCurrentPage ] = useState<string>("start");
  // 編集モード
  const [isEdit, setIsEdit] = useState(false);
  // ユーザー初期値
  const userData = { userNo: 1, name: "新患 ", isNewPatient: "", patientId: "", templateId: 0, isLineLinked: false}
  // 患者情報
  const [ userInfo, setUserInfo ] = useState([userData]);
  // 設定中の患者
  const [ currentUser, setCurrentUser] = useState(userData);
  const [ currentUserNo, setCurrentUserNo ] = useState<number>(0);
  // 患者数
  const [ patientCount, setPatientCount ] = useState(1);
  const patientCountValue = { patientCount, setPatientCount };
  // 患者検索結果
  const [ patientList, setPatientList ] = useState([]);
  // 検索ワード
  const [ searchWord, setSearchWord] = useState("");
  // インタビューキー
  const [ interviewKey, setInterviewKey ] = useState("");
  // 選択中テンプレートID
  const [ currentTemplate, setCurrentTemplate] = useState({template_code: ""});
  // ロード
  const [isLoading, setIsLoading]  = useState<Boolean>(true);
  // レンダリング用
  const [update, setUpdate] = useState<Boolean>(false);
  // テンプレート
  const [templates, setTemplates] = useState([]);
  const [newTemplates, setNewTemplates] = useState([]);
  const [returnTemplates, setReturnTemplates] = useState([]);
  // メッセージ送信患者ID
  const [sendMessagePatientId, setSendMessagePatientId] = useState("");

  // 初期ロード
  useEffect(() =>{
    axios.get(
      '/api/internal/templates/get_interview_templates', {
      })
      .then(function (response) {
        setTemplates(response.data.templates);
        setNewTemplates(response.data.new_templates);
        setReturnTemplates(response.data.return_templates);
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
        alert(error.response.data.message)
      }
    ); 
  }, [])  


  // 選択中のユーザーが変更されたとき 
  useEffect(() =>{
    // 選択中のユーザー情報更新
    setCurrentUser(userInfo.find(user => user.userNo === currentUserNo));
  },[currentUserNo])

  // 来局人数が変更されたとき
  useEffect(() =>{
    const users = userInfo.slice(0,1);
    for (let i = 2; i <= patientCount; i++) {
      users.push({ userNo: i, name: "新患 ", isNewPatient: "", patientId: "", templateId: 0, isLineLinked: false});
    }
    setUserInfo(users);
    setCurrentUserNo(1);
    setCurrentPage("start");
  },[patientCount])

  useEffect(() =>{
    if(isEdit){
      changePage("start","");
    }
    return
  },[isEdit])

  // 先確認データ登録
  function submitInterview(nextPage){
    setIsLoading(true);
    axios.post(
      '/api/internal/interview/setup', {
        patients: userInfo
      })
      .then(function (response) {
        setIsLoading(false);
        switch(nextPage){
          case "interview" :
            const key = "/interview/index?interview_key=" + response.data.interview_key + "&is_lend=true";
            location.href = (key);
            break;
          case "urlCopy" :
            setInterviewKey(response.data.interview_key);
            const line_users = userInfo.filter( v => v.isLineLinked == true);
            line_users.length === 1 && setSendMessagePatientId(line_users[0].patientId);
            setCurrentPage(nextPage);
          default :
            setInterviewKey(response.data.interview_key);
            setCurrentPage(nextPage);
        }
        
      })
      .catch(error => {
        setIsLoading(false);
        alert(error.response.data.message);
      }); 
  }

  // 患者検索
  function searchPatients(){
    setIsLoading(true);
    axios.get(
      '/api/internal/patients/get_patients', {
        params: {
          search_word: searchWord,
          limitFlg: 1,
          isGooco: true
        }
      })
      .then(function (response) {
        setIsLoading(false);
        const m_patients = response.data.m_patients 
        setPatientList(m_patients);
      })
      .catch(error => {
        setIsLoading(false);
        setPatientList([]);
        alert(error.response.data.message);
      }); 
  }

  // LINE連携チェック
  function getPatientLineLinked(){
    axios.get(
      '/api/internal/patients/check_line_linked', {
        params: {
          m_patient_id: currentUser.patientId
        }
      })
      .then(function (response) {
        const currentUserDup = currentUser
        currentUserDup.isLineLinked = response.data.line_linked
        setCurrentUser(currentUserDup);
      })
      .catch(error => {
        alert(error.response.data.message);
      });
  }

  // LINE送信
  function sendLineMessage(){
    setIsLoading(true);
    axios.post(
      '/api/internal/messages/send_line_message', {
          m_patient_id: sendMessagePatientId,
          url: "https://" + location.hostname + "/interview/index?interview_key=" + interviewKey,
      })
      .then(function () {
        const element = document.getElementById("send_complate_button");
        element.click();
        setIsLoading(false);
      })
      .catch(error => {
        const element = document.getElementById("send_error_button");
        element.click();
        setIsLoading(false);
      }); 
  }

  function calcAge(birthdayStr){
    if(isNaN(birthdayStr)||birthdayStr.length !== 8){
      return -1;
    }
    const date = new Date();
    const dateStr = '' + date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2);
    return Math.floor((parseInt(dateStr)-parseInt(birthdayStr))/10000);
  };

  // ページ遷移用
  function changePage(pageName, value) {
    const currentUserDup = currentUser

    switch(currentPage){
      case "start":
        currentUserDup.isNewPatient = value;
        currentUserDup.name = "";
        currentUserDup.patientId = "";

        setCurrentUser(currentUserDup);
        setSearchWord("");
        break;
      
      case "gender":
        if(value){
          const template = searchTemplate(value);
          currentUserDup.templateId = value;
          currentUserDup.name = "新患";
        } else {
          currentUserDup.templateId = 0;
          currentUserDup.name = "";
        }
        setCurrentUser(currentUserDup);
        // 編集モードだった場合は、編集モードを終了して、確認画面へ遷移
        if(isEdit && value != ""){
          setIsEdit(false);
          pageName = "confirmation";
        }
        break;
      case "patientId":
        // 戻るボタンが押された場合は実行しない
        if(pageName === "patientTemplate"){
          setIsLoading(true);
          getPatientTemplate();
          getPatientLineLinked();
          setIsLoading(false);
        }
        break;
      case "patientTemplate":
        if(value){
          currentUserDup.templateId = value;
        } else {
          currentUserDup.templateId = 0;
        }
        setCurrentUser(currentUserDup);
        // 編集モードだった場合は、編集モードを終了して、確認画面へ遷移
        if(isEdit && value != ""){
          setIsEdit(false);
          pageName = "confirmation";
        }
        break;
    }

    // 患者検索の場合は検索項目
    (pageName === "patientId" && currentPage != "patientTemplate") && setPatientList([]);
      
    setCurrentPage(pageName);
  }

  const setViewPatient = (user) => {
    const template = searchTemplate(user.templateId);

    if (user.isNewPatient === "true"){
      return(
          <h3>新患({template.display_web_name})</h3>
      )
    } else {
      return(
          <h3>再来({template.display_web_name})</h3>
      )
    }
  }

  function interviewStatusPage(){
    location.href = ('/interview_status/index')
  }

  function getPatientTemplate(){
    axios.get(
      '/api/internal/interview/get_revisited_patient_template', {
        params: {
          patientId: currentUser.patientId
        }
      })
      .then(function (response) {
        setCurrentTemplate(response.data.m_template);
      })
      .catch(error => {
        alert(error.response.data.message);
      });
  }

  // ページ
  const pages = () => {
    switch(currentPage){
      case 'start':
        return(
          <>
            <div className="row">
              <div className="col-md-3 col-sm-3 d-xs-none" />
              <div className="col-md-6 col-sm-6 col-xs-12">
                <input key={"start" + 1} type="button" className="radio-button" value="新患" onClick={() => changePage("gender", "true")}/>
              </div>
              <div className="col-md-3 col-sm-3 d-xs-none" />
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-3 d-xs-none" />
              <div className="col-md-6 col-sm-6 col-xs-12">
                <input key={"start" + 2} type="button" className="radio-button" value="再来" onClick={() => changePage("patientId", "false")}/> 
              </div>
            <div className="col-md-3 col-sm-3 d-xs-none" />
           </div>
          </>
        )
      case 'gender':
        return(
          <div className="scroll template-area">
            { newTemplates.map((template) =>
              <div className="row">
                <div className="col-md-3 col-sm-3 d-xs-none" />
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <input key={"gender_" + template.id} type="button" className="radio-button" value={template.display_web_name} onClick={() => changeUser(template.id, 1)}/>
                </div>
                <div className="col-md-3 col-sm-3 d-xs-none" />
              </div>
            )}
          </div> 
        )
      case 'patientTemplate':
        return(
          <div className="scroll template-area">
            { returnTemplates.map((template) =>
              <div className="row">
                <div className="col-md-3 col-sm-3 d-xs-none" />
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <input 
                    key={"gender_" + template.id} 
                    type="button" 
                    className="radio-button"
                    value={currentTemplate.template_code === template.template_code ? template.display_web_name +"（前回選択しています）" : template.display_web_name}
                    onClick={() => changeUser(template.id, 1)}
                  />
                </div>
                <div className="col-md-3 col-sm-3 d-xs-none" />
              </div>
            )}
          </div> 
        )
      case 'patientId':
        return(
          <>
            <div className="row">
              <div className="col-md-3 col-sm-3 d-xs-none" />
              <div className="form-group col-md-6 col-sm-6 col-xs-12">
                <label htmlFor="reception_number text-center">検索したい内容を入力してください(氏名・カナ氏名・携帯電話番号・患者番号・生年月日)</label>
                <input key="search_word" type="text" className="form-control" id="reception_number" placeholder="検索したい内容を入力してください" onChange={(e) => setSearchWord(e.target.value)}/>
              </div>
              <div className="col-md-3 col-sm-3 d-xs-none" />
            </div>

            <div className="row">
              <div className="col-md-4 col-sm-4 d-xs-none" />
              <div className="col-md-4 col-sm-4 col-xs-12">
                <input key="search_button" type="button" className="radio-button" value="検索" onClick={() => searchPatients()}/>
              </div>
              <div className="col-md-4 col-sm-4 d-xs-none" />
            </div>
            <div className="interview-table-sticky">
              <table className="table table-bordered">
                <thead>
                  <tr className="interview-table-head">
                    <th className="col-md-1 col-sm-1 col-xs-1"></th>
                    <th className="col-md-2 col-sm-2 col-xs-2">患者番号</th>
                    <th className="col-md-3 col-sm-3 col-xs-3">患者名</th>
                    <th className="col-md-3 col-sm-3 col-xs-3">生年月日(年齢)</th>
                    <th className="col-md-4 col-sm-4 col-xs-4">携帯電話番号</th>
                  </tr>
                </thead>

                <tbody className="interview-table">
                  {
                    patientList.map((patient) => {
                      return (
                        <>
                          <tr 
                            className={currentUser.patientId == patient.id ? ("interview-table-tr interview-selected"):("interview-table-tr")}
                            key={"patient_" + patient.id}
                          >
                            <td key={"id_" + patient.id} className="text-center">
                              <input
                                id={"radio_" + patient.id} 
                                className="search-patient"
                                type="radio" 
                                name="patientRadio" 
                                value={patient.id}
                                defaultChecked={currentUser.patientId == patient.id}
                                onChange={(e) => changePatientId(e.target.value)}
                              />
                            </td>
                            <td key={"consultation_ticket_no_" + patient.id}>
                              <label htmlFor={"radio_" + patient.id} >{patient.consultation_ticket_no}</label>
                            </td>
                            <td key={"name_" + patient.id}>
                              <label htmlFor={"radio_" + patient.id} >{patient.name}</label>
                            </td>
                            <td key={"birthday_" + patient.id}>
                              <label htmlFor={"radio_" + patient.id} >
                              { patient.birthday ? patient.japanese_calendar_birthday + '（' + calcAge(patient.birthday.replace(/-/g , '')) + '）' : ''}
                              </label>
                            </td>
                            <td key={"mobile_phone_" + patient.id}>
                              <label htmlFor={"mobile_phone_" + patient.id} >{patient.mobile_phone}</label>
                            </td>
                          </tr>
                        </>  
                      )  
                    })
                  }
                </tbody>
              </table>
            </div>  
          </>
        )
      case 'confirmation':
        return(
          <>
            <table className="table table-bordered interview-table">
              <tbody>
                {userInfo.map((user) => {
                  return(
                      <tr>
                          <td className="col-md-1 col-sm-1 col-xs-1">
                            <h3 className="text-center">{user.userNo}</h3>
                          </td>

                          <td className="col-md-5 col-sm-5 col-xs-5">
                            { setViewPatient(user) }
                          </td>
                          
                          <td className="col-md-5 col-sm-5 col-xs-5">
                            {
                              user.isNewPatient === "true" ? (
                                <h3>新患</h3>
                              ) : (
                                <h3>{user.name}</h3>
                              )
                            }
                          </td>
                            
                          <td className="col-md-1 col-sm-1 col-xs-1 text-center">
                            <span data-testid={"edit_button_" +user.userNo} className="glyphicon glyphicon-edit edit-icon" aria-hidden="true" onClick={()=> changeEditMode(user.userNo)}/>
                          </td>  
                      </tr>  
                  );  
                })}
              </tbody>
            </table>
          </>
        )
      case 'qrCode':
        return(
          <>
            <div className="col-md-12 col-sm-12 col-xs-12 text-center">
              <h3 className="question-title">QRコードを読み取ってください</h3>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 text-center"/>
            <div className="col-md-12 col-sm-12 col-xs-12 text-center">
              <QRCode value={"https://" + location.hostname + "/interview/index?interview_key=" + interviewKey} size="200"/>
            </div>
          </>
        )
      case 'urlCopy':
        return(
          <>
            <div className="col-md-1 col-sm-1 d-xs-none text-center"/>
            <div className="form-group col-md-10 col-sm-10 col-xs-12">
                  <input
                    key="clipboard"
                    type="text"
                    className="form-control text-center"
                    readOnly={true}
                    defaultValue={"https://" + location.hostname +"/interview/index?interview_key=" + interviewKey}
                  />
            </div>
            <div className="col-md-1 col-sm-1 d-xs-none text-center" />

            <div className="col-md-5 col-sm-5 d-xs-none text-center"/>
            <div className="col-md-2 col-sm-2 d-xs-12 text-center">
              <input
                type="button"
                className="interview-page-button"
                onClick={() => copyButton()}
                value="コピー"
              />
            </div>
            <div className="col-md-5 col-sm-5 d-xs-none text-center"/>
            <div className="col-md-12 col-sm-12 d-xs-12 text-center"/>
            <div className="col-md-1 col-sm-1 d-xs-none text-center" />
            {
              userInfo.some( e => e.isLineLinked == true) ? 
              (
                <>
                  <div className="col-md-10 col-sm-10 col-xs-12 text-center interview-table-sticky">
                    <table className="table table-bordered interview-table">
                      <thead>
                        <tr className="interview-table-head">
                          <th className="col-md-2 col-sm-2 col-xs-2"></th>
                          <th className="col-md-10 col-sm-10 col-xs-10 text-center">患者名</th>
                        </tr>
                      </thead>
                      <tbody>
                        { userInfo.map((user) => {
                          return(
                            <>
                            { user.isLineLinked && (
                              <tr className={sendMessagePatientId == user.patientId ? ("interview-table-tr interview-selected"):("interview-table-tr")}>
                                <td className="col-md-2 col-sm-2 col-xs-2">
                                  { sendMessagePatientId === user.patientId ? (
                                    <input id={"radio_" + user.patientId} className="send-line-patient" type="radio" name="sendLinePatient" value={user.patientId} onChange={(e) => setSendMessagePatientId(e.target.value)} checked/>
                                  ):(
                                    <input id={"radio_" + user.patientId} className="send-line-patient" type="radio" name="sendLinePatient" value={user.patientId} onChange={(e) => setSendMessagePatientId(e.target.value)}/>
                                  )}
                                  
                                </td>
                                <td className="col-md-10 col-sm-10 col-xs-10">
                                  <label htmlFor={"radio_" + user.patientId} className="col-md-12 col-sm-12 col-xs-12">{user.name}</label>
                                </td>
                              </tr>  
                            )}
                            </>
                          )
                          })}
                    </tbody>
                  </table>
                </div>
                <div className="col-md-1 col-sm-1 d-xs-none text-center" />
                <div className="col-md-5 col-sm-5 d-xs-none text-center"/>
                {
                  sendMessagePatientId != "" && (
                    <div className="col-md-2 col-sm-2 d-xs-12 text-center">
                      <input
                        type="button"
                        className="interview-page-button"
                        onClick={() => sendLineMessage()}
                        value="送信"
                      />
                      <input id="send_complate_button" type="hidden"　data-toggle="modal" data-target="#send_complate_modal"/>
                      <input id="send_error_button" type="hidden" data-toggle="modal" data-target="#send_error_modal"/>
                      
                    </div>
                  )
                }

                <div className="col-md-5 col-sm-5 d-xs-none text-center"/>
              </>
              ):(
                <div className="col-md-10 col-sm-10 col-xs-12 text-center">
                  <h3 className="red">メッセージ送信（LINE）可能な患者が存在しません。</h3>
                </div>
              )
            }


          </>
        )        
    }
  }

  // ボタン切り替え
  const buttons = () => {
    switch(currentPage){
      case 'start':
        return(
          <>
            
              { (currentUserNo != 1 && !isEdit) ? (
                <>
                  <div className="col-md-2 col-sm-2 col-xs-12">
                    <li className="previous">
                      <a className="pager-button" onClick={() => changeUser("", -1)}>戻る</a>
                    </li>
                  </div>
                  <div className="col-md-2 col-sm-2 col-xs-12">
                    <li className="previous">
                      <a className="pager-button" onClick={() => interviewStatusPage()}>受付一覧に戻る</a>
                    </li>
                  </div>
                </>
                ) : (
                  <>
                  <div className="col-md-2 col-sm-2 col-xs-12">
                    <li className="previous">
                      <a className="pager-button" onClick={() => interviewStatusPage()}>受付一覧に戻る</a>
                    </li>
                  </div>
                  <div className="col-md-2 col-sm-2 d-xs-none"/>
                  </>
                )
              }  
            <div className="col-md-8 col-sm-8 d-xs-none"/>
          </>
        )     

      case 'patientId':
        return(
          <>
            <div className="col-md-2 col-sm-2 col-xs-12">
              <li className="previous">
                <a className="pager-button" onClick={(e) => changePage("start", "")}>戻る</a>
              </li>
            </div>

            <div className="col-md-2 col-sm-2 col-xs-12">
              <li className="previous">
                <a className="pager-button" onClick={() => interviewStatusPage()}>受付一覧に戻る</a>
              </li>
            </div>

            <div className="col-md-6 col-sm-6 d-xs-none" />

            <div className="col-md-2 col-sm-2 col-xs-12"> 
              <li className="next">
               {currentUser.patientId != "" && (
                 <a className="pager-button disabled" onClick={() => changePage("patientTemplate", "")}>次へ</a>
                )
               }
              </li>
            </div>
          </>
        )
      case 'patientTemplate':
       return(
        <>
          <div className="col-md-2 col-sm-2 col-xs-12">
            <li className="previous">
              <a className="pager-button" onClick={(e) => changePage("patientId", "")}>戻る</a>
            </li>
          </div>

          <div className="col-md-2 col-sm-2 col-xs-12">
            <li className="previous">
              <a className="pager-button" onClick={() => interviewStatusPage()}>受付一覧に戻る</a>
            </li>
          </div>

          <div className="col-md-8 col-sm-8 d-xs-none"/>
        </>  
       )
      case 'gender':
        return(
          <>
            <div className="col-md-2 col-sm-2 col-xs-12">
              <li className="previous">
                <a className="pager-button" onClick={(e) => changePage("start", "")}>戻る</a>
              </li>
            </div>
            <div className="col-md-2 col-sm-2 col-xs-12">
              <li className="previous">
                <a className="pager-button" onClick={() => interviewStatusPage()}>受付一覧に戻る</a>
              </li>
            </div>

            <div className="col-md-8 col-sm-8 d-xs-none"/>
          </>
        )        
      case 'confirmation' :
        return(
          <>
            
            <div className="col-md-2 col-sm-2 col-xs-12">
              <li className="previous">
                <a className="pager-button"  onClick={(e) => changePage("start", "")}>戻る</a>
              </li>
            </div>

            <div className="col-md-2 col-sm-2 col-xs-12">
              <li className="previous">
                <a className="pager-button"  onClick={(e) => interviewStatusPage()}>受付一覧に戻る</a>
              </li>
            </div>

            <div className="col-md-2 col-sm-2 d-xs-none" />

            <div className="col-md-2 col-sm-2 col-xs-12">
              <li className="previous">
                <a className="pager-button" onClick={() => submitInterview("urlCopy")}>URL</a>
              </li>
            </div>


            <div className="col-md-2 col-sm-2 col-xs-12">
              <li className="previous">
                <a className="pager-button" onClick={() => submitInterview("qrCode")}>QRコード</a>
              </li>
            </div>

            <div className="col-md-2 col-sm-2 col-xs-12"> 
              <li className="next">
                <a className="pager-button" onClick={() => submitInterview("interview")}>スタート</a>
              </li>
            </div>

            <div className="col-md-1 col-sm-1 d-xs-none" />
          </>
        )
      case 'qrCode':
        return(
          <>
            <div className="col-md-2 col-sm-4 col-xs-12">
              <li className="previous">
                <a className="pager-button" onClick={() => interviewStatusPage()}>受付一覧に戻る</a>
              </li>
            </div>
          </>
        )
      case 'urlCopy':
        return(
          <>
            <div className="col-md-2 col-sm-4 col-xs-12">
              <li className="previous">
                <a className="pager-button" onClick={() => interviewStatusPage()}>受付一覧に戻る</a>
              </li>
            </div>
          </>
        )        
    }
  }

  // ユーザー切り替え 
  function changeUser(value, count){
    if (currentUserNo === patientCount && currentPage != "start") {
      changePage('confirmation', value); 
    } else {
      // 編集モードだった場合は、最大値を設定
      if (isEdit) {
        setCurrentUserNo(patientCount);
      } else {
        setCurrentUserNo(currentUserNo + count);
      }
      
      changePage("start", value);
    }
  }

  // 編集モード
  function changeEditMode(userNo){
    setCurrentUserNo(userNo);
    setIsEdit(true);
  }

  // 再来情報設定
  function changePatientId(id){
    const currentUserDup = currentUser
    const patient = patientList.find(patient => patient.id == id)

    currentUserDup.patientId = id;
    currentUserDup.name = patient.name;
    setCurrentUser(currentUserDup);

    // 再レンダー用
    setUpdate(update?false:true);
  }

  function copyButton() {
    if (window.clipboardData){ // IE対応
      window.clipboardData.setData("Text" ,"https://" + location.hostname +"/interview/index?interview_key=" + interviewKey);
    } else {
      navigator.clipboard.writeText("https://" + location.hostname +"/interview/index?interview_key=" + interviewKey);
    }
  }

  function searchTemplate(templateId){
    const template = templates.find(templates => templates.id == templateId);
    return template;
  }

  function viewTitle(){
    switch(currentPage){
      case 'confirmation':
        return(
          <>
            <div className="col-md-4 col-sm-4 col-xs-4">
              <h3 className="question-title">患者設定確認</h3> 
            </div>
            <div className="col-md-3 col-sm-3 col-xs-3" />
              <div className="col-md-4 col-sm-4 col-xs-4 text-right">
                <h3 className="question-title">{"患者人数：" + patientCount + "名"}</h3>
              </div>
              <div className="col-md-1 col-sm-1 col-xs-1">
                <span className="glyphicon glyphicon-edit edit-icon" aria-hidden="true" data-toggle="modal" data-target="#myModal"/>
            </div>
          </>
        )
      case 'qrCode':
        return(
          <>
            <div className="col-md-3 col-sm-3 col-xs-3" />
            <div className="col-md-6 col-sm-6 col-xs-6 text-center">
              <h3 className="question-title">先確認QRコード表示画面</h3>
            </div>
            <div className="col-md-3 col-sm-3 col-xs-3" />
          </>
        )
      case 'urlCopy':
        return(
          <>
            <div className="col-md-2 col-sm-2 col-xs-2" />
            <div className="col-md-8 col-sm-8 col-xs-8 text-center">
              <h3 className="question-title">URLのコピーまたはメッセージ送信（LINE）を行ってください</h3>
            </div>
            <div className="col-md-2 col-sm-2 col-xs-2" />
          </>
        )
      default:
        return(
          <>
            <div className="col-md-4 col-sm-4 col-xs-4">
              <h3 className="question-title">{currentUserNo + "人目の患者様"}</h3> 
            </div>

            <div className="col-md-3 col-sm-3 col-xs-3" />
              <div className="col-md-4 col-sm-4 col-xs-4 text-right">
                <h3 className="question-title">{"患者人数：" + patientCount + "名"}</h3>
              </div>
              <div className="col-md-1 col-sm-1 col-xs-1">
                <span className="glyphicon glyphicon-edit edit-icon" aria-hidden="true" data-toggle="modal" data-target="#myModal"/>
            </div>
          </>  
        )
    }
  }

  return(
    <>
     <LoadingOverlay
      active={isLoading}
      spinner
      text='Loading...'
      >
        <div className="row row-height-flex full margin-all-0">
          <div className="panel panel-defalut col-md-12 col-sm-12 col-xs-12 padding-left-0 padding-right-0 border-none margin-all-0">
            <div className="panel-body bg-green height-100">
              <div className="panel panel-defalut col-md-12 col-sm-12 col-xs-12 height-85 bg-subscreen">
                <div className="panel-body">
                  <div className="row">
                    {viewTitle()}
                  </div>
                  <hr className="border-top-5"/>
                  {pages()}
                  </div>
                </div>
              <div className="row">
                <ul className="pager">
                  {buttons()}
                </ul>
              </div> 
            </div>
          </div>
        </div>

        {/* モーダル */}
        <div id="myModal" className="modal fade" data-backdrop="static" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content bg-subscreen">
              <div className="modal-header text-center">
                <h3 className="question-title">患者人数を選択してください</h3>
              </div>
              <div className="modal-body">
                <PatientCount.Provider value={patientCountValue}>
                  <NumberPatients />
                </PatientCount.Provider> 
              </div>  
            </div>
          </div>
        </div>  
        
        {/* 送信完了モーダル */}
        <div className="modal fade" data-backdrop="static" id="send_complate_modal">
          <div className="sw-modal-content">
            <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
            <div className="swal2-icon swal2-success animate-success-icon" style={{display: "block"}}>
              <span className="line tip"/> <span className="line long"/><div className="placeholder"/><div className="fix"/>
            </div>
              <h2>メッセージ送信（LINE）</h2>
              <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                メッセージ送信（LINE）が完了しました。<br />
              </div>
              <a type="button"
                  className="sw-modal-btn"
                  style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
                  data-dismiss="modal"
                  onClick={() => interviewStatusPage()}
                >
              受付一覧に戻る
              </a>
            </div>
          </div>
        </div>

        {/* 送信失敗モーダル */}
        <div className="modal fade" data-backdrop="static" id="send_error_modal">
          <div className="sw-modal-content">
            <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
              <div className="swal2-icon swal2-error animate-error-icon" style={{display: "block"}}>
                <span className="x-mark animate-x-mark">
                  <span className="line left"/><span className="line right"/>
                </span>
              </div>
              <h2>メッセージ送信（LINE）</h2>
              <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
                メッセージ送信（LINE）に失敗しました。<br />
              </div>
              <button type="button" className="sw-modal-btn" data-dismiss="modal">閉じる</button>
            </div>
          </div>
        </div>
        </LoadingOverlay>
    </>
  )
}

export default index
